"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// index.ts
var index_exports = {};
__export(index_exports, {
  backups: () => backups,
  collections: () => collections,
  externalDatabaseConnections: () => externalDatabaseConnections,
  indexes: () => indexes,
  items: () => items,
  movementJobs: () => movementJobs,
  permissions: () => permissions,
  tasks: () => tasks
});
module.exports = __toCommonJS(index_exports);
var tasks = __toESM(require("@wix/auto_sdk_data_tasks"));
var permissions = __toESM(require("@wix/auto_sdk_data_permissions"));
var externalDatabaseConnections = __toESM(require("@wix/auto_sdk_data_external-database-connections"));
var backups = __toESM(require("@wix/auto_sdk_data_backups"));
var collections = __toESM(require("@wix/auto_sdk_data_collections"));
var indexes = __toESM(require("@wix/auto_sdk_data_indexes"));
var movementJobs = __toESM(require("@wix/auto_sdk_data_movement-jobs"));
var items = __toESM(require("@wix/wix-data-items-sdk"));
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  backups,
  collections,
  externalDatabaseConnections,
  indexes,
  items,
  movementJobs,
  permissions,
  tasks
});
//# sourceMappingURL=index.js.map